// Errores del compilador de plantillas que la ficha TOLERA a proposito.
//
// El markup de la ficha lo escribe details.blade.php y lo compila el runtime
// de Vue en el navegador. Cada replica SSR sigue el patron
// `<span v-text="x">{{ texto Blade }}</span>`: el Blade pinta el texto para el
// primer paint y Vue lo sustituye al montar. Vue 2 lo aceptaba; el compilador
// de Vue 3 lo considera un error (X_V_TEXT_WITH_CHILDREN, y X_V_HTML_WITH_CHILDREN
// para v-html), aunque despues vacia los hijos y sigue compilando igual que
// Vue 2 hacia. En desarrollo ese error solo se imprime; en produccion el
// runtime no pasa `onError` y el compilador LANZA, y la ficha entera se queda
// sin montar ("Uncaught SyntaxError: https://vuejs.org/error-reference/#compiler-57",
// visto en el primer canary de produccion, 2026-09-06).
//
// Cambiar el Blade no es opcion mientras exista el bundle Vue 2 congelado
// (docs/frontend/product-page.md): el mismo markup alimenta a los dos. Asi que
// el entry de la ficha instala este `onError`, que traga solo esos dos codigos
// y relanza cualquier otro.
//
// Los codigos son los de @vue/compiler-dom 3.5.42 (DOMErrorCodes). Van
// escritos a mano porque vue.esm-bundler.js embebe su propio compilador y no
// importa @vue/compiler-dom: importarlo aqui duplicaria el compilador en
// product-details.js. tests/js/product-compiler-errors.test.js los contrasta
// contra el paquete instalado: si una actualizacion de Vue los mueve, falla.
export const X_V_HTML_WITH_CHILDREN = 55;
export const X_V_TEXT_WITH_CHILDREN = 57;

export const TOLERATED_COMPILER_ERRORS = new Set([
    X_V_HTML_WITH_CHILDREN,
    X_V_TEXT_WITH_CHILDREN,
]);

/**
 * `onError` para `app.config.compilerOptions` (llega al compilador via
 * compileToFunction, que lo fusiona sobre su valor por defecto).
 *
 * @param {Error & { code?: number }} error
 */
export function onCompilerError(error) {
    if (error && TOLERATED_COMPILER_ERRORS.has(error.code)) {
        return;
    }

    throw error;
}
